import(/* webpackMode: "eager", webpackExports: ["ProductPageWrapper"] */ "/home/runner/work/holibob/holibob/booking-web/app/[locale]/product/[input]/ProductPageWrapper.tsx");
